/**
 * Sign snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_Sign
 * @extends Snippet
 */

Snippet_Sign = (function (Snippet) {

	var Snippet_Sign = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Sign.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function (parent, config) {
			this.$lastFocused = null;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function () {
			if (this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-sign");
			}
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function () {
			this.clear();

			// make HTML template
			var html = this.getTemplate({});

			// append HTML to DOM
			this.$el.html(html);
			this.$overlay = $('#overlay', this.$el);
			this.$signShadow = $('#sign', this.$el);
            this.$signTitle = $('#sign-title', this.$el);
            this.$buscarTitle = $('#buscar-title', this.$el);
		},

		/**
		 * To get HTML template
		 */
		getTemplate: function (data) {
			var isLogged = User.isLogged();
			var html = '<div id="overlay" style="display:none;" ><div id="focus-out" class="focusable"/><div id="fake-focus"/></div>'
			html += '<div id="sign">';
			html += '<div '+(isLogged ? '' : 'class="focusable" data-action="" ')+'id="sign-wrapper">'
			if (isLogged) {
				html += '<div id="sign-title" class="user focusable" data-action="account"><i id="sign-icon" class="logged"></i></div>';
			} else {
				html += '<div id="sign-title" class="login focusable" data-action="login"> '+ __('sign_in') + '<i id="sign-icon"></i></div>';
			}
            html += '<div id="buscar-title" class="login focusable" data-action="search"><i id="search-icon"></i></div>';
			html += '</div>';
			html += '</div>';
			return html;
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function ($el, event) {
			if (this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function ($el, event) {
			var data_action = $el.attr('data-action');
            switch(data_action){
                case 'login':
                    this.$signShadow.removeClass('focused');			
			        this.$overlay.hide();
			        Router.go('signin');
                    break;
                case 'logout':
                    this.$signShadow.removeClass('focused');			
			        this.$overlay.hide();
                    API.signOut();
                    break;
                case 'search':
                    this.$signShadow.removeClass('focused');			
			        this.$overlay.hide();
			        Router.go('search');
					break;
				case 'account':
                    this.$signShadow.removeClass('focused');			
			        this.$overlay.hide();
			        Router.go('account');
                    break;
            }
			return false;
		},
		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function (direction) {
            switch (direction) {
                case 'down':
                    this.$overlay.hide();
				    this.$signShadow.removeClass('focused');
                    this.trigger("focus:out", this, direction);
                    break;                
                case 'right':
                    Focus.to(this.$signTitle);
                    break;                    
                case 'left':
                    Focus.to(this.$buscarTitle);
                    break;            
            }
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function ($el) {
			if (!$el) {
				//$el = this.getFocusable();
                $el = document.getElementById('buscar-title');
			}
			return Focus.to($el);
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function ($el) {
			if ($el.attr('id') === 'focus-out') {
				this.navigate('down');
			} else {
				this.$overlay.show();
				this.$signShadow.addClass('focused');
				this.$lastFocused = $el;
			}
		},

		clear: function () {
			this.$el.empty();
			this.$lastFocused = null;
		},

		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		},

		onReturn: function ($el, event) {
			this.$signShadow.removeClass('focused');			
			this.$overlay.hide();
			this.trigger("focus:out", this); 
			return false;
		},

	});

	return Snippet_Sign;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/sign.js
// module id = 75
// module chunks = 0